import React, { FC } from 'react';
import BodyText from '@fenderdigital/ui/BodyText';
import Box from '@fenderdigital/ui/Box';
import SelectBox from '@fenderdigital/ui/SelectBox';
import Spacer from '@fenderdigital/ui/Spacer';
import Spinner from '@fenderdigital/ui/Spinner';
import { HStack, VStack } from '@fenderdigital/ui/Stacks';
import { useCountriesContext } from '../../contexts/CountriesContext';

const Countries: FC = () => {
  const {
    countryCode,
    approvedCountries,
    nonApprovedCountries,
    isLoadingCountries,
    setCountryCodeValue,
  } = useCountriesContext();
  const handleChange = (value: string): void => {
    setCountryCodeValue(value);
  };

  const allCountries = [...approvedCountries, ...nonApprovedCountries].sort().map(val => ({
    label: val,
    value: val,
  }));
  const currentCountryOption = allCountries.find(country => country.value === countryCode);
  return (
    <Box bgColor="transparent" padding="sp0" height="12rem">
      {isLoadingCountries ? (
        <Spinner width="2rem" strokeBaseColor="white" strokeColor="transparent" />
      ) : (
        <>
          <HStack spacing="sm3">
            <BodyText textSize="f3" textColor="white" weight="bold">
              Current Country Code:
            </BodyText>
            <BodyText textSize="f3" textColor="white">
              {countryCode}
            </BodyText>
          </HStack>
          <Spacer />
          <VStack>
            {allCountries && (
              <SelectBox
                label="Country Codes"
                onChange={handleChange}
                options={allCountries}
                value={currentCountryOption?.value}
              />
            )}
          </VStack>
        </>
      )}
    </Box>
  );
};

export default React.memo(Countries);
